export default "__VITE_ASSET__DhqHVljB__"